import React, { Component } from "react";

import { withTranslation } from "react-i18next";
import {
  IconButton,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export class DRXLayout extends Component {
  render() {
    const {
      t,
      classes,
      handleClickDRXKey,
      handleMouseDownDRXKey,
      showDRXKey,
      readOnly,
      drx_key,
      handleChangeDRXKey,
    } = this.props;
    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <FormControl
            className={classes.formControl}
            style={{ marginTop: "15px" }}
          >
            <InputLabel htmlFor="password" style={{ marginLeft: "-1rem" }}>
              {t("Accounts.Connect.DRX.DRXKkey")}
            </InputLabel>
            <Input
              className={classes.halfTextField}
              margin="normal"
              value={drx_key || ""}
              id="drx_key"
              name="drx_key"
              type={showDRXKey ? "text" : "password"}
              inputProps={{ readOnly: Boolean(readOnly) }}
              label="Password"
              placeholder=""
              onChange={handleChangeDRXKey}
              validators={["required"]}
              errorMessages={[t("Validation.EnterXApiKey")]}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickDRXKey}
                    onMouseDown={handleMouseDownDRXKey}
                  >
                    {showDRXKey ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
      </React.Fragment>
    );
  }
}

export default (withTranslation()(DRXLayout));



// WEBPACK FOOTER //
// ./src/components/account-list/third-party/drx.js